module.exports = __webpack_public_path__ + "static/media/view admitted student.b410a494.svg";